import { WHITE, colorMap, BLUE_PRIMARY } from 'constants/colors';

const friendlyColorMap = Object.keys(colorMap).reduce((acc, val) => {
  const colorName = val.toLowerCase().replace(/_/g, '-');
  acc[colorName] = colorMap[val];

  return acc;
}, {});

export const getBackgroundColor = (colorName, fallbackToTransparent = true) => {
  const colorOptions = {
    ...friendlyColorMap
  };

  return (
    colorOptions[colorName] ||
    (fallbackToTransparent ? 'transparent' : fallbackToTransparent)
  );
};

export const contrastingTextColor = colorName => {
  const colorOptions = {
    'blue-primary': WHITE,
    'blue-dark': WHITE,
    'blue-light': WHITE,
    salmon: BLUE_PRIMARY,
    green: WHITE,
    gray: BLUE_PRIMARY,
    pink: BLUE_PRIMARY,
    white: BLUE_PRIMARY
  };

  return colorOptions[colorName] || 'inherit';
};
